(function () {
  var button = document.querySelector('.zaynoo-back-to-top');
  if (!button) return;

  var threshold = 400;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toggleButton() {
    var shouldShow = window.scrollY > threshold;
    button.hidden = !shouldShow;
    button.classList.toggle('is-visible', shouldShow);
  }

  button.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
    button.blur();
  });

  window.addEventListener('scroll', toggleButton, { passive: true });
  toggleButton();
})();
